import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuienesSomos from './components/QuienesSomos';
import Services from './components/Services';
import Solutions from './components/Solutions';
import Proyectos from './components/Proyectos';
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <QuienesSomos />
      <Services />
      <Solutions />
      <Proyectos />
      <Clients />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
